export const getAggregatorGameStatusDisplayValue = (value: string): string => {
  if (value === "CLAIMED") return "COMPLETED"
  if (value === "NOT_FOUND") return "NOT STARTED"

  return value
}

export const getNativeGameStatusDisplayValue = (row: any): string => {
  return row.completed ? "COMPLETED" : isExpired(row) ? "EXPIRED" : "NOT STARTED"
}

export const getGameStatusColor = (displayValue: string): string => {
  if (displayValue === "NOT STARTED") return "grey"
  if (displayValue === "PENDING") return "orange"
  if (displayValue === "EXPIRED") return "red"

  return "green"
}

export const isExpired = task => {
  if (!task.expiresAt) return false
  const now = new Date()
  const expiresAt = new Date(task.expiresAt)

  return expiresAt < now
}

export const isCashbackTask = (type: string) => type === "CASHBACK_TASK" || type === "WATCH_AN_ADS_TASK"
